import axios from "axios";
import { cmsHeaders } from "../exports/exports";
import { dynamicFailed } from "../hooks/useToast";

export const fetchArchiveBanner = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/archive-banner`,
      { headers: cmsHeaders },
    );
    return response.data.slice(-1);
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
  }
};

// export const fetchVideoData = async () => {
//   try {
//     const response = await axios.get(
//       `${process.env.REACT_APP_strapiUrl}/api/frcsit-archive-videos?populate=*`,
//       { headers }
//     );
//     return response.data.data;
//   } catch (error) {
//     dynamicFailed("Server Error");
//   }
// };

export const fetchVideoFilesData = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/${process.env.REACT_APP_cmsProjectId}/archive-file`,
      { headers: cmsHeaders },
    );
    return response.data;
  } catch (error: any) {
    dynamicFailed(`${error.message}`);
  }
};
